// No seconds
export function getTimeString(rawHours) {
  const totalMinutes = Math.floor(rawHours * 60); // whole minutes
  const wholeHours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  const days = Math.floor(wholeHours / 24);
  const hours = wholeHours % 24;
  let resString = '';
  resString += !!days ? days + 'd ' : '';
  resString += !!hours ? hours + 'h ' : '';
  resString += !!minutes ? minutes + '\'' : '';
  return resString.trim();
}
export function getDistanceString(rawKms) {
  const kms = Math.floor(rawKms);
  const ms = Math.floor((rawKms - kms) * 1000);
  let resString = '';
  resString += !!kms ? kms + 'km ' : '';
  resString += !!ms ? ms + 'm' : '';
  return resString.trim();
}
export const stringEndsWithNumber = (str) => {
  return /\d$/.test(str);
};
